import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { upgradeReasons } from "@zapier/upsells/esm/types";
import { LogoImage } from "./LogoImage";
const imageCss = css({
    svg: { height: "100%", width: "100%" },
});
const imageContainerCss = css `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
`;
const imageMap = {
    [upgradeReasons.emailSupport]: "UpgradeNudgeEmailSupport",
    [upgradeReasons.multistep]: "UpgradeNudgeMultistep",
    [upgradeReasons.paths]: "UpgradeNudgePaths",
    [upgradeReasons.premium]: "UpgradeNudgeApps",
    [upgradeReasons.premiumLimit]: "UpgradeNudgeApps",
    [upgradeReasons.taskLimit]: "UpgradeNudgeTaskLimit",
    [upgradeReasons.taskLimitLow]: "UpgradeNudgeTaskLimitLow",
    [upgradeReasons.zapLimit]: "UpgradeNudgeZaps",
};
export const NudgeImage = ({ type, appName }) => {
    const fileName = imageMap[type];
    let ImageSvg;
    try {
        ImageSvg = require(`./images/${fileName}`).default;
    }
    catch {
        ImageSvg = null;
    }
    return ImageSvg ? (_jsxs("div", { css: [imageContainerCss, imageCss], children: [_jsx(ImageSvg, {}), [
                upgradeReasons.premium,
                upgradeReasons.premiumLimit,
            ].includes(type) && _jsx(LogoImage, { app: appName })] })) : null;
};

// @zapier/upsells@8.0.3 (1de7a616e)
